import { Either } from "fp-ts/lib/Either";
import ShiftEntity from "../../../../../domain/entities/ShiftEntity";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";

//TODO implement
const CreateShiftApiImpl = (shift: ShiftEntity):  Promise<Either<ExceptionEntity, ShiftEntity>> =>{
    throw new Error('Method not implemented.');
}

export default CreateShiftApiImpl;